import type { AxiosResponse } from 'axios';

export const apiRequestCache = new Map<string, { expiresAt: number; promise: Promise<AxiosResponse>; generation: number }>();
let generation = 0;
export function clearApiRequestCache(): void { generation++; apiRequestCache.clear(); }
export function apiCacheGeneration(): number { return generation; }

function canonical(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonical);
  if (value instanceof Date) return value.toISOString();
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).map(([key, item]) => [key, canonical(item)]));
  }
  return value;
}

export function apiCacheKey(baseURL: string, url: string, query: unknown, headers: unknown, responseType: unknown): string {
  return JSON.stringify([baseURL, url, canonical(query), canonical(headers), responseType]);
}
